import React from "react";
import "../Style/requestDemo.css";
import RequestWrapper from "../Components/RequestWrapper";
const RequestDemo = () => {
  return <RequestWrapper />;
};

export default RequestDemo;
